export default "__VITE_ASSET__C0NZ4wWH__"